export class StorageModel {

    /**
     * Selected wallet
     */
    wallet: string | null = null;

    /**
     * Selected wallet accounts
     */
    accounts: Array<StorageAccountModel> = [];

    /**
     * Selected settings
     */
    settings: StorageSettingsModel = new StorageSettingsModel();
}

export class StorageAccountModel {

    /**
     * Account address
     */
    address: string = '';

    /**
     * Whether account is active
     */
    active: boolean = false;
}

export class StorageSettingsModel {

    /**
     * Data indexer
     */
    indexer: string = 'graphql';

    /**
     * Graphql provider
     */
    graphql: string = 'official';

    /**
     * Jsonrpc provider
     */
    jsonrpc: string = 'official';
}